import React from "react";
import { Element } from "react-scroll";

import About from "./about";
import Homepage from "./homepage";
import Projects from "./projects";
import Experience from "./experience";
import Contact from "./contact";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";

const Index = () => {
	return (
		<React.Fragment>
			<div className="page-content">
				<div className="content-wrapper">
					<NavBar />
					<Element name="home">
						<Homepage />
					</Element>
					<hr />
					<Element name="about">
						<About />
					</Element>
                    <hr />
					<Element name="projects">
						<Projects />
					</Element>
                    <hr />
					<Element name="experience">
						<Experience />
					</Element>
                    <hr />
					<Element name="contact">
						<Contact />
					</Element>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Index;
